import { Model } from 'app/model/backendmodel';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { GlobalVariables } from 'app/services/globals';
/**
 * This service is used to hold the loaded workspace from the A365WorkspaceService
 * in order to avoid a circular dependecy between MetadataClientFactoryService and
 * A365WorkspaceService.
 */
@Injectable({
    providedIn: 'root'
})
export class A365WorkspaceCacheService {
    public readonly sqlPoolNoPermission$ = new BehaviorSubject<boolean>(false);

    private readonly _workspace$ = new BehaviorSubject<Model.Workspace | undefined>(undefined);
    public get workspace(): Model.Workspace | undefined {
        return this._workspace$.value;
    }
    public set workspace(value: Model.Workspace | undefined) {
        this._workspace$.next(value);
    }
    public get workspace$(): Observable<Model.Workspace | undefined> {
        return this._workspace$;
    }

    public isWorkspaceLite(): boolean {
        const extraProperties = this.workspace && this.workspace.properties ? this.workspace.properties.extraProperties : null;
        return extraProperties != null && extraProperties.WorkspaceType === 'Connected';
    }

    public isWorkspaceDisconnected(): boolean {
        const extraProperties = this.workspace && this.workspace.properties ? this.workspace.properties.extraProperties : null;
        return extraProperties != null && extraProperties.WorkspaceType === 'Disconnected';
    }

    public isBabylonEnabled(): boolean {
        return this.workspace && this.workspace.properties && (
            !!this.workspace.properties.purviewConfiguration && !!this.workspace.purviewConfiguration.purviewResourceId);
    }

    public get isDEPEnabled(): boolean {
        const workspace = this.workspace;
        return workspace?.properties?.managedVirtualNetworkSettings?.preventDataExfiltration === true;
    }

    public isSosWorkspace(): boolean {
        const { enableScopeOnSynapseForAutoTest } = GlobalVariables;
        if (typeof enableScopeOnSynapseForAutoTest === 'boolean') {
            return enableScopeOnSynapseForAutoTest;
        }

        const extraProperties = this.workspace && this.workspace.properties ? this.workspace.properties.extraProperties : null;
        return extraProperties != null && extraProperties.IsScopeEnabled;
    }
}
